import css from 'styled-jsx/css';

const styles = css.global`iframe {
  width: 100%;
  height: 500px;
}`;

export default styles;